/**
 * @file fetch-icon-cfg.ts
 *
 * Fetches remote icon variant configuration and merges it into
 * liveAppData._iconList. Reads app-id and custom-icon-variants attributes
 * from the as-app element. Called once from AsApp.connectedCallback
 * (fire-and-forget).
 */
import { liveAppData } from '../../store/store.ts';
import { fetchResource } from '../../logic/asApi.ts';

export function fetchIconCfg(el: HTMLElement): void {
  const root = 'https://apps.trinckle.com';
  const appId = el.getAttribute('app-id');
  const appPath = appId ? `apps/${appId}` : '';
  const customIconVariants = el.hasAttribute('custom-icon-variants');
  const iconPaths = [`${root}/data/base-icon-variants.cfg.js`];
  if (customIconVariants) iconPaths.push(`${root}/${appPath}/data/icon-variants.cfg.js`);

  Promise.all(
    iconPaths.map(path => fetchResource(path).catch(() => ({})))
  )
    .then(results => {
      liveAppData._iconList = {
        ...liveAppData._iconList,
        ...results.reduce((acc, variants) => ({ ...acc, ...variants }), {}),
      };
    })
    .catch(err => console.error('Error loading icon variants:', err));
}
